import { Box, Tooltip, Typography } from "@mui/material";
import CustomChip from "../../core/custom-chip";
import CustomPopper from "../../core/custom-popper";
import { TICKET_STAGES } from "../../pages/admin/ticket-details-v2/helper";
import { convertToCamelCaseFromUnderScore } from "../../utils";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Ticket ID",
    id: "id",
    onClick: true,
    render: (data, onClick) => {
      return (
        <span className="clickable" onClick={() => onClick(data)}>
          {data.id}
        </span>
      );
    },
  },
  {
    label: "Created On",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}{" "}
          {data.createdAt && new Date(data.createdAt).toLocaleTimeString()}
        </span>
      );
    },
  },
  {
    label: "Created By",
    id: "createdBy",
    render: (data) => {
      return <span>{data?.createdBy?.name}</span>;
    },
  },
  {
    label: "OEM Org",
    id: "oem",
    render: (data) => {
      return <span>{data?.oemOrg?.name}</span>;
    },
  },
  {
    label: "OEM Engineer",
    id: "oemServiceEngineerName",
    render: (data) => {
      return <span>{data?.complaintRecord?.oemServiceEngineerName}</span>;
    },
  },
  {
    label: "Engine Serial Number",
    id: "engineNo",
  },
  {
    label: "Complaint Description",
    id: "customerComplaintCode",
    render: (data) => {
      return <span>{data?.customerComplaintCode?.description}</span>;
    },
  },
  {
    label: "Ticket Stage",
    id: "stage",
    render: (data) => {
      const engineReplacementStatus =
        data?.engineReplacement &&
        data?.engineReplacementStatus &&
        data?.engineReplacementStatus !== "APPROVED"
          ? convertToCamelCaseFromUnderScore(data?.engineReplacementStatus)
          : false;
      return (
        <>
          <span>{TICKET_STAGES[data.stage]}</span>
          <div
            style={{
              fontWeight: "bold",
              color:
                data?.engineReplacementStatus === "YET_TO_DISPATCH"
                  ? "red"
                  : "green",
            }}
          >
            {" "}
            {engineReplacementStatus && `(${engineReplacementStatus})`}
          </div>
        </>
      );
    },
  },
  {
    label: "Service Engineer",
    id: "serviceEngineer",

    render: (data) => {
      return (
        <Tooltip
          title={
            <Box sx={{ width: "200px" }}>
              {data?.serviceEngineer?.name ? (
                <div>
                  <Typography sx={{ textAlign: "center" }}>
                    {data.serviceEngineer.name}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }}>
                    {data?.serviceEngineer?.email}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }}>
                    {data?.serviceEngineer?.phoneNumber}
                  </Typography>
                </div>
              ) : (
                "Service Engineer	Not Assigned"
              )}
            </Box>
          }
          arrow
        >
          <span>{data?.serviceEngineer?.name || "Not assigned"}</span>
        </Tooltip>
      );
    },
  },
  {
    label: "Status",
    id: "status",
    render: (data) => {
      const value = getStatus(data);
      return (
        <span>
          <CustomChip
            label={value}
            colorKey={
              value === "Resolved"
                ? "green"
                : value === "Open"
                ? "orange"
                : "blue"
            }
          />
        </span>
      );
    },
  },
];
export const viewFormConfig = [
  {
    name: "oemName",
    type: "text",
    label: "Name of OEM",
    placeholder: "Name of OEM",
  },
  {
    name: "oemServiceEngineerName",
    type: "text",
    label: "Service Eng Name",
    placeholder: "Service Eng Name",
  },
  {
    name: "oemServiceEngineerContact",
    type: "text",
    label: "Service Eng Contact",
    placeholder: "Service Eng Contact",
  },

  {
    name: "tractorAddress",
    type: "text",
    label: "Address",
    placeholder: "Address",
  },
  {
    name: "state",
    type: "text",
    label: "State",
    placeholder: "State",
  },
  {
    name: "city",
    type: "text",
    label: "City",
    placeholder: "City",
  },
  {
    name: "pinCode",
    type: "text",
    label: "Pin Code",
    placeholder: "Pin Code",
  },
  {
    name: "oemDealerName",
    type: "text",
    label: "OEM Dealer Name",
    placeholder: "OEM Dealer Name",
  },
  {
    name: "engineSerialNumber",
    type: "text",
    label: "Engine Serial Number",
    placeholder: "Engine Serial Number",
  },
  {
    name: "unitMachineStatus",
    type: "text",
    label: "Unit / Machine Current Status",
    placeholder: "Unit / Machine Current Status",
  },
  {
    name: "unitSerialNumber",
    type: "text",
    label: "Unit Serial Number",
    placeholder: "Unit Serial Number",
  },
  {
    name: "dateOfSale",
    type: "text",
    label: "Date of Sale",
    placeholder: "Date of Sale",
  },
  {
    name: "customerComplaintDate",
    type: "text",
    label: "Customer Complaint Date",
    placeholder: "Customer Complaint Date",
  },
  {
    name: "natureOfCustomerComplaint",
    type: "text",
    label: "Customer Complaint Nature",
    placeholder: "Customer Complaint Nature",
  },
  {
    name: "hmr",
    type: "text",
    label: "HMR",
    placeholder: "HMR",
  },
  {
    name: "customerName",
    type: "text",
    label: "Customer Name",
    placeholder: "Customer Name",
  },
  {
    name: "customerContact",
    type: "text",
    label: "Customer Contact",
    placeholder: "Customer Contact",
  },
  // {
  //   name: "cutInNumber",
  //   type: "text",
  //   label: "Cut In Number",
  //   placeholder: "Cut In Number",
  // },
  {
    name: "investigationDetailsByOem",
    type: "text",
    label: "Investigation Details By OEM",
    placeholder: "Investigation Details By OEM",
  },
  {
    name: "remarks",
    type: "text",
    label: "Remarks",
    placeholder: "Remarks",
  },
  {
    name: "customerRegularApplication",
    type: "text",
    label: "Customer Regular Application",
    placeholder: "Customer Regular Application",
  },
  {
    name: "applicationWhileComplaintObserved",
    type: "text",
    label: "Complaint Observed Application",
    placeholder: "Complaint Observed Application",
  },
  {
    name: "soilCondition",
    type: "text",
    label: "Soil Condition",
    placeholder: "Soil Condition",
  },
  {
    name: "actionTakenByOem",
    type: "text",
    label: "Action Taken by OEM",
    placeholder: "Action Taken by OEM",
  },
  {
    name: "cqc",
    type: "text",
    label: "CQC",
    placeholder: "CQC",
  },
];
export const SERVICE_LABEL_MAP = {
  firstService: "1st Service",
  secondService: "2nd Service",
  thirdService: "3rd Service",
  fourthService: "4th Service",
};

export const getStatus = (data) => {
  const { underWarranty, status, serviceEngineer, dateOfInspection } = data;
  // if (
  //   status === "OPENED" &&
  //   underWarranty &&
  //   serviceEngineer &&
  //   dateOfInspection
  // ) {
  //   return "JI Date fixed";
  // } else if (status === "OPENED" && underWarranty && serviceEngineer) {
  //   return "Engineer Assigned";
  // } else if (status === "OPENED" && underWarranty) {
  //   return "Acknowledged";
  // } else if (status === "OPENED") {
  //   return "Open";
  // } else {
  //   return convertToCamelCaseFromUnderScore(status);
  // }
  if (status === "OPENED") {
    return "Open";
  } else if (status === "REOPENED") {
    return "Reopen";
  } else {
    return convertToCamelCaseFromUnderScore(status);
  }
};
